import { ChainId } from "@uniswap/sdk-core";
export const SUBSCRIPTION_CHAINIDS = [
  ChainId.MAINNET,
  ChainId.ARBITRUM_ONE,
  ChainId.BNB,
  ChainId.OPTIMISM,
  ChainId.POLYGON,
  ChainId.CELO
];
